import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error-client'

const Turnaround = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [woSearch, setWoSearch] = useState(false);
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);
   
    const [client, setClient] = useState({
        client_id: params.client_id,
    });



    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => row.facility_name + "_" + row.facility_city + " "+ row.facility_state,
                id: "wo_creation_date",
                cell: ({ getValue }) => (
                    <span>
                        <ul className="table-ul">
                            {(getValue().split("_")).map((p, index) => (
                                <li key={index}>{p}</li>
                            ))}
                        </ul>
                    </span>
                ),
                header: () => "FACILITY",
                footer: props => props.column.id
            },
            {
                accessorKey: "count_cases",
                header: "TOTAL CASES",
                footer: props => props.column.id
            },
            {
                accessorKey: "avg_turnaround",
                header: "AVG TURNAROUND",
                footer: props => props.column.id
            },
            
        ],
        []
    )

    useEffect(() => {

       // getClients();
       // getFacilitiesNames();
        searchWorkOrders();
       

    }, []);





    const searchWorkOrders = () => {

        setIsLoading(true);
        var search_elements = {}

        search_elements.start_date = woSearch?.start_date;
        search_elements.end_date = woSearch?.end_date;
        search_elements.facility_name = woSearch?.facility_name;
        search_elements.case_manager_first_name = woSearch?.case_manager_first_name;

      

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-report-turnaround", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">WORK ORDERS - TURNAROUND TIME</h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">

                            <div className="col-3 my-1">
                                <label htmlFor="client_id" >FACILITY</label>


                                <input name="facility_name" className="form-control" type="text"
                                    value={woSearch.facility_name}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, facility_name: e })
                                    }
                                />


                            </div>

                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">START DATE</label>

                                <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) =>{
                    
                                        var dt = new Date(e);
                  
                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");
                      
                                        const formatted_date = month + '/' + day + '/' + year
                                        setWoSearch({ ...woSearch, start_date: formatted_date })
                                        
                                      }
                                    }
                                />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">END DATE</label>

                                <DatePicker name="end_date" id="end_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.end_date}
                                    onChange={(e) => {
                    
                                        var dt = new Date(e);
                  
                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");
                      
                                        const formatted_date = month + '/' + day + '/' + year
                                        setWoSearch({ ...woSearch, start_end: formatted_date })
                                        
                                      }
                                    }
                                />
                            </div>


                          
                        <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="client_id" >CASE MANAGER</label>


                        <input name="case_manager_first_name" className="form-control" type="text"
                            value={woSearch.case_manager_first_name}
                            onChange={(e) =>
                                setWoSearch({ ...woSearch, case_manager_first_name: e })
                            }
                           

                        />
  </div>

                

            </div>


        </form >

                </div >

    <div className="card-footer">
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button" disabled={isLoading?true:false} >{isLoading?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SEARCH"} </button>
                <button onClick={() => { setWoSearch(null) }} className="btn btn-warning mx-1" type="button">CLEAR SEARCH </button>
            </div>

        </div>
    </div>
            </div >




    {(workOrders || isLoading) &&

    <div className="card card-form card-primary mt-4 " >
        <div className="card-body p-0 mb-0" >

            {isLoading ?
                <div className="loader">
                    <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                </div>
                :
                <PrimaryTable columns={columns} data={workOrders} canFilter={false} />
            }


        </div>
    </div>

            }


        </>


    );
};

export default Turnaround;